module.exports = "{{this.data.message}}\r\n"